// src/components/auth/GlassCard.jsx
// src/components/auth/GlassCard.jsx

import { motion } from "framer-motion";

export default function GlassCard({
  children,
  className = "",
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className={`
        w-full
        rounded-[28px]
        bg-white/85
        backdrop-blur-xl
        border border-white/70
        shadow-[0_25px_60px_rgba(15,23,42,0.18)]
        overflow-hidden
        ${className}
      `}
    >
      {children}
    </motion.div>
  );
}


// // src/components/auth/GlassCard.jsx
// import { motion } from "framer-motion";

// export default function GlassCard({ children }) {
//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 24 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.35 }}
//       className="
//         w-full max-w-md
//         rounded-3xl
//         bg-white/40
//         backdrop-blur-2xl
//         border border-white/50
//         shadow-[0_30px_60px_rgba(0,0,0,0.2)]
//         p-8
//       "
//     >
//       {children}
//     </motion.div>
//   );
// }



// // components/auth/GlassCard.jsx
// import { motion } from "framer-motion";

// export default function GlassCard({ children }) {
//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 24 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.35 }}
//       className="
//         w-full max-w-md
//         rounded-3xl
//         bg-white/30 backdrop-blur-xl
//         border border-white/40
//         shadow-[0_20px_50px_rgba(0,0,0,0.15)]
//         p-6 sm:p-8
//       "
//     >
//       {children}
//     </motion.div>
//   );
// }
